import React from 'react';
import MainBody from '../components/main-body';
import Contents from '../components/contents';

export default function Landing() {
    return (
        <>
            <MainBody />
            <Contents />
        </>
    )
}